import { Component } from '@angular/core';

import { ModalComponent } from '@shared/modal/modal.component';

@Component({
    selector: 'checkout-loading-modal',
    templateUrl: './loading-modal.component.html',
    styleUrl: 'loading-modal.component.scss',
    imports: [ModalComponent],
    standalone: true,
})
export class LoadingModalComponent extends ModalComponent {}
